import { moduleFactory } from "@/factories/module";
import { registerGlobalKeyboardShortcutHandler } from "@/modules/keyboard/registerGlobalKeyboardShortcutHandler";

export const keyboardModule = moduleFactory.create({
  registerGlobalShortcutHandler: registerGlobalKeyboardShortcutHandler,
});
